import { useState } from 'react';
import { ClickAwayListener, makeStyles, Tooltip, Zoom } from '@material-ui/core';
import useMobile from '../../utils/useMobile';
import { RemarksBgIcon } from '../Icon';
import { onKeyUpEnterOrSpace } from '../../utils';

const useStylesLongremarkTooltip = makeStyles((theme) => ({
  arrow: {
    color: '#4073d2',
    '&::before': {
      boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    },
  },
  tooltip: ({ width, minWidth }) => ({
    borderRadius: '0.625rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: '#4073d2',
    padding: '1.188rem 0.688rem 1.188rem 1.188rem',
    color: theme.palette.font.white,
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    width,
    minWidth,
    whiteSpace: 'pre-line',
  }),
}));

const useStyles = makeStyles(() => ({
  markiconBtn: {
    borderRadius: '0',
    padding: '0',
    marginLeft: '0.625rem',
    display: 'flex',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  markicon: {
    fontSize: '1.25rem',
    color: '#c0c6cb',
  },
}));

const LongRemark = ({ content, minWidth, width = '18.125rem', placement, id }) => {
  const [isPad] = useMobile();
  const longremarkclasses = useStylesLongremarkTooltip({ width, minWidth });
  const classes = useStyles();
  const [toolTipOpen, setToolTipOpen] = useState(false);

  const handleTooltipClose = (event) => {
    event.stopPropagation();
    setToolTipOpen(false);
  };

  const handleTooltipOpen = (event) => {
    event.stopPropagation();
    isPad && setToolTipOpen(true);
  };

  return isPad ? (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        id={id}
        classes={longremarkclasses}
        title={content}
        arrow
        TransitionComponent={Zoom}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        onClose={handleTooltipClose}
        open={toolTipOpen}
      >
        <div
          className={classes.markiconBtn}
          onClick={handleTooltipOpen}
          tabIndex={0}
          onKeyUp={(e) => onKeyUpEnterOrSpace(e, handleTooltipOpen)}
        >
          <RemarksBgIcon className={classes.markicon} />
        </div>
      </Tooltip>
    </ClickAwayListener>
  ) : (
    <Tooltip id={id} classes={longremarkclasses} title={content} arrow TransitionComponent={Zoom} placement={placement}>
      <div className={classes.markiconBtn}>
        <RemarksBgIcon className={classes.markicon} />
      </div>
    </Tooltip>
  );
};

export default LongRemark;
